import { Button } from 'dingtalk-design-mobile'
import './PsychiatristSuccess.less'
import useHistory from '@/hooks/useHistory'

const PsychiatristSuccess = () => {

  const history = useHistory()

  const handleClick = (step) => {
    history.back(step)
  }
  return (
    <div className="pg-psychiatrist-success">
      <div className='pg-psychiatrist-success--container'>
        <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/success-icon.png' />
        <div className='status'>提交成功</div>
        <div className='tips'>已收到您的咨询，我们会及时处理！</div>
        <div className='btns'>
          <Button className='btn' onClick={() => handleClick(2)}>完成</Button>
          <Button className='btn continue' onClick={() => handleClick(1)}>继续咨询</Button>
        </div>
      </div>
    </div>
  )
}

export default PsychiatristSuccess